import { inject, injectable } from 'inversify';

import { HttpService } from 'src/core/services/http.service';

@injectable()
export class EmailDocumentService {
	@inject(HttpService)
	private httpService: HttpService;

	private baseUrl = 'api/v1/email';

	public sendDocumentEmail(targetIds: number[], fileIds: number[], emailTemplateId: number, usage: DocumentGenerationUsage) {
		if (emailTemplateId != 0)
			return this.httpService.post(`${this.baseUrl}/document/send`, {
				targetIds, fileIds, emailTemplateId, usage
			});
	}

	public getDocumentTemplates(id: number, targetId: number, usages: DocumentGenerationUsage ){
		return this.httpService.get(`${this.baseUrl}/document/templates/${usages}/${id || 0}/${targetId}`);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/email-document.service.ts